<full-screen-loading></full-screen-loading>
<app-outdated-browser-warning></app-outdated-browser-warning>
<icp-alert></icp-alert>
<router-outlet></router-outlet>